import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

export default function PaketInceleme({ apiUrl, onGeri, onSoruSec }) {
  const { authFetch } = useAuth();
  const [paketler, setPaketler] = useState([]);
  const [seciliPaket, setSeciliPaket] = useState(null);
  const [paketSorular, setPaketSorular] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(false);

  // Paket listesini yukle (aggregate endpoint)
  useEffect(() => {
    async function yukle() {
      setYukleniyor(true);
      try {
        const r = await authFetch(`${apiUrl}/api/analiz/paket-listesi`);
        const data = await r.json();
        const satirlar = data.satirlar || [];

        // paket_no'ya gore aggregate satirlardan ozet kur
        const paketMap = {};
        satirlar.forEach(row => {
          const pNo = row.paket_no;
          if (!paketMap[pNo]) paketMap[pNo] = { no: pNo, soru_sayisi: 0, dersler: new Set(), durumlar: {} };
          paketMap[pNo].soru_sayisi += row.adet;
          if (row.ders) paketMap[pNo].dersler.add(row.ders);
          paketMap[pNo].durumlar[row.durum] = (paketMap[pNo].durumlar[row.durum] || 0) + row.adet;
        });

        // Durum kararı: tüm sorular onaylı → 'onaylandi'; en az biri reddedildi → 'reddedildi'; aksi → 'bekliyor'
        const paketler = Object.values(paketMap).map(p => {
          const toplam = p.soru_sayisi;
          const onayli = p.durumlar['onaylandi'] || 0;
          const reddedilen = p.durumlar['reddedildi'] || 0;
          let durum = 'bekliyor';
          if (onayli === toplam) durum = 'onaylandi';
          else if (reddedilen > 0) durum = 'reddedildi';
          return { no: p.no, soru_sayisi: toplam, dersler: [...p.dersler], durum };
        });

        setPaketler(paketler.sort((a, b) => a.no - b.no));
      } catch (e) { console.error(e); }
      setYukleniyor(false);
    }
    yukle();
  }, [apiUrl, authFetch]);

  const paketSec = async (paket) => {
    setSeciliPaket(paket);
    setPaketSorular([]);
    try {
      const r = await authFetch(`${apiUrl}/api/sorular?paket_no=${paket.no}&limit=200`);
      const data = await r.json();
      setPaketSorular(data.sorular || []);
    } catch (e) { console.error(e); }
  };

  const durumRenk = (d) => ({
    onaylandi: 'bg-green-100 text-green-800',
    reddedildi: 'bg-red-100 text-red-800',
    bekliyor: 'bg-yellow-100 text-yellow-800'
  }[d] || 'bg-gray-100 text-gray-800');

  const durumIcon = (d) => ({
    onaylandi: '\u2705', reddedildi: '\u274C', bekliyor: '\u23F3'
  }[d] || '\u2753');

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <button onClick={onGeri} className="text-blue-600 hover:text-blue-800 font-bold">&larr; Geri</button>
        <h2 className="text-xl font-bold text-gray-800">Paket Inceleme</h2>
      </div>

      {yukleniyor ? (
        <div className="text-center text-gray-500 py-10">Yukleniyor...</div>
      ) : !seciliPaket ? (
        /* Paket Listesi */
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {paketler.length === 0 ? (
            <div className="col-span-3 text-center text-gray-400 py-10">Henuz paket yok. CLI ile paket uretin.</div>
          ) : paketler.map(p => (
            <div key={p.no} onClick={() => paketSec(p)}
              className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 cursor-pointer hover:shadow-md transition-all">
              <div className="flex justify-between items-center mb-3">
                <h3 className="text-lg font-bold text-gray-800">Paket {p.no}</h3>
                <span className={`px-2 py-1 rounded-full text-xs font-semibold ${durumRenk(p.durum)}`}>
                  {durumIcon(p.durum)} {p.durum}
                </span>
              </div>
              <div className="text-sm text-gray-600">
                <div>{p.soru_sayisi} soru</div>
                <div className="mt-1 text-xs text-gray-400">
                  {p.dersler.map(d => (d || '').replace('_', ' ')).join(', ')}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        /* Paket Detay */
        <div>
          <div className="flex items-center gap-3 mb-4">
            <button onClick={() => setSeciliPaket(null)} className="text-blue-600 hover:text-blue-800 text-sm">&larr; Paketler</button>
            <h3 className="text-lg font-bold">Paket {seciliPaket.no} — {paketSorular.length} soru</h3>
            <span className={`px-2 py-1 rounded-full text-xs font-semibold ${durumRenk(seciliPaket.durum)}`}>
              {seciliPaket.durum}
            </span>
          </div>

          <div className="space-y-4">
            {paketSorular.map((s, i) => (
              <div key={s.id} className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                <div className="flex justify-between items-start mb-2">
                  <div className="flex items-center gap-2">
                    <span className="bg-blue-600 text-white w-7 h-7 rounded-full flex items-center justify-center text-sm font-bold">{i + 1}</span>
                    <span className="text-sm font-semibold text-gray-700">{s.konu}</span>
                  </div>
                  <div className="flex gap-2">
                    <span className="text-xs px-2 py-0.5 rounded bg-gray-100">{s.zorluk}</span>
                    <span className="text-xs px-2 py-0.5 rounded bg-gray-100">{s.dogru_cevap}</span>
                  </div>
                </div>
                <div className="text-sm text-gray-600 mb-2 line-clamp-3">
                  {(s.soru_metni_latex || '').replace(/\\[a-zA-Z]+/g, '').substring(0, 200)}...
                </div>
                {onSoruSec && (
                  <button onClick={() => onSoruSec(s.id)}
                    className="text-blue-600 text-xs hover:underline">
                    Detay
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
